<template>
  <h3>个股雪球</h3>
  <StockSearchForm @submit="fetchData" :isSubmitting="isSubmitting" />
 <div v-if="loading" class="loading-mask">
        <div class="loading-spinner"></div>
        <p>加载中...</p>
      </div>

    <div class="filter-group"  v-if="filteredTableData.length > 0">
      <!-- 类型过滤 -->

        <div class="filter-title">类型：</div>
        <el-radio-group v-model="selectedStructure" @change="applyFilter">
          <el-radio-button
            v-for="option in options"
            :key="option.value"
            :label="option.value"
          >
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="filter-group"  v-if="filteredTableData.length > 0">
      <!-- 金额过滤 -->

        <div class="filter-title">金额：</div>
        <el-radio-group v-model="selectedStructure_amount" @change="applyPrice">
          <el-radio-button
            v-for="option in total_principal_options"
            :key="option.value"
            :label="option.value"
          >
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </div>
       <div class="filter-group"  v-if="filteredTableData.length > 0">
      <!-- 期权公司过滤 -->

        <div class="filter-title">期权公司：</div>
        <el-radio-group v-model="selectedBrokerage" @change="applyBrokerageFilter">
          <el-radio-button
            v-for="option in brokerage_options"
            :key="option.value"
            :label="option.value"
          >
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </div>

      <!-- 期权时长过滤 -->
       <div class="filter-group"  v-if="filteredTableData.length > 0">
        <div class="filter-title">期权时长：</div>
        <el-radio-group v-model="selectedTimes" @change="applyBrokerageFilter">
          <el-radio-button
            v-for="option in times_options"
            :key="option.value"
            :label="option.value"
          >
            {{ option.label }}
          </el-radio-button>
        </el-radio-group>
      </div>


    <div v-if="filteredTableData.length > 0">
      <StockTableXQ :tableData="filteredTableData" :now_str="now_str" />
    </div>

</template>


<script>
import axios from 'axios';
import StockSearchForm from '@/components/StockSearchForm.vue';
import StockTableXQ from '@/components/StockTableXQ.vue';
import { formatDate } from '@/utils/commonMethods';
export default {
  name: 'StockSearchFormPageXQ',
  components: {
    StockSearchForm,
    StockTableXQ
  },
  data() {
    return {
       date: new Date(),
      isSubmitting: false,
      searchQuery: '',
      warring: '',
      tableData: [],
      originalTableData: [],  // 添加原始数据副本
      selectedStructure: '不追保雪球',
      selectedStructure_amount: '1',
      selectedBrokerage: 'all',  // 初始化为默认值
      selectedTimes:'all',
      options: [
        { value: '不追保雪球', label: '不追保雪球' },
        { value: '追保雪球', label: '追保雪球' },
        { value: '折价建仓雪球', label: '折价建仓雪球' },
      ],
      total_principal_options: [
        { value: '1', label: '100w' },
        { value: '2', label: '200w' },
        { value: '3', label: '300w' },
        { value: '4', label: '400w' },
        { value: '5', label: '500w' }
      ],
      brokerage_options: [
        { value: 'all', label: '全部' },
        { value: '银河_雪球', label: '银河_雪球' },
        { value: '中证_雪球', label: '中证_雪球' },
        { value: '中金_雪球', label: '中金_雪球' },
        { value: '浙期_雪球', label: '浙期_雪球' },
        { value: '国君_雪球', label: '国君_雪球' },

      ],
       times_options: [
        { value: 'all', label: '全部' },
        { value: '6M', label: '6M' },
        { value: '12M', label: '12M' },

      ],
      total_principal: '1',  // 初始化为默认值
      total_principal_label: '100w',  // 用于存储 label 值
      containerDisplay:false,
      loading: false, // ✅ 新增 loading 状态
    }
  },
  computed: {
    formattedDate() {
      return this.date ? formatDate(this.date) : '';
    },
    totalPages() {
      return Math.ceil(this.totalRecords / this.perPage);
    },
    filteredTableData() {
      let filteredData = this.tableData;

      if (this.selectedStructure) {
        const startIndex = filteredData.findIndex(item => item.structure === this.selectedStructure);
        if (startIndex !== -1) {
          filteredData = filteredData.slice(startIndex, startIndex + 16);
        } else {
          filteredData = [];
        }
      }

      if (this.selectedBrokerage !== 'all') {
        filteredData = filteredData.filter(item => item[this.selectedBrokerage] !== 0);
      }
      if (this.selectedTimes !== 'all') {
       filteredData = filteredData.filter(item => item.term.includes(this.selectedTimes));
      }

      return filteredData;
    }
  },
  methods: {
    applyPrice() {
      // 根据 selectedStructure_amount 计算倍数
      const selectedOption = this.total_principal_options.find(option => option.value === this.selectedStructure_amount);

      this.total_principal = selectedOption.value;
      this.total_principal_label = selectedOption.label;  // 直接使用 this.total_principal_label

      this.tableData = this.originalTableData.map(item => {
        return {
          ...item,
          银河_雪球: item.银河_雪球 * this.total_principal,
          中证_雪球: item.中证_雪球 * this.total_principal,
          浙期_雪球: item.浙期_雪球 * this.total_principal,
          国君_雪球: item.国君_雪球 * this.total_principal,
          中金_雪球: item.中金_雪球 * this.total_principal,
        };
      });
      this.tableData[0].total_principal_label = this.total_principal_label;
    },
    async fetchData(searchQuery,date) {
      if (this.isSubmitting) return;
      console.log('开始请求数据:', searchQuery);
      this.isSubmitting = true;
      this.loading = true; // ✅ 显示加载动画
      try {
        const response = await axios.get(`/api/query_xq`,{
              headers: {
                 'Authorization': `Bearer ${this.$store.getters.token}`
             },
              params: { now_date: date,code:searchQuery }
        });
        const responseData = response.data;

        if (responseData.stock_data_list != null) {
          this.data = responseData;
          console.log('got data:', this.data);
          this.generateTableData();
          this.containerDisplay = false;
        }else {
             this.data={};
             this.originalTableData =[];
             this.$message.error( responseData.error||'不是两融标的');
        }
      } catch (error) {
         if (error.response && error.response.data && error.response.data.detail) {
            this.$message.error(error.response.data.detail);
          } else {
             this.$message.error( this.data.error);
          }

      } finally {
        this.loading = false; // ✅ 隐藏加载动画
        this.isSubmitting = false;
        console.log('请求完成');
      }
    },
    generateTableData() {
      const { date, stock_code, stock_name, stock_data_list } = this.data;
      console.log('generateTableData:', stock_data_list);
      this.now_str = this.data.now_str;
      this.tableData = [
        // ... 你的 tableData 生成逻辑 ...
        { date, stock_code, stock_name, structure: '不追保雪球',total_principal_label: this.total_principal_label, term: '70-100 6M', ...this.extractValues(stock_data_list, [2,20,99,99,99])},
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103 6M', ...this.extractValues(stock_data_list, [3,21,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100 6M', ...this.extractValues(stock_data_list, [4,22,99,5,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103 6M', ...this.extractValues(stock_data_list, [5,23,99,2,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100 6M', ...this.extractValues(stock_data_list, [6,24,99,6,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103 6M', ...this.extractValues(stock_data_list, [7,25,99,3,14]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-100 6M', ...this.extractValues(stock_data_list, [8,26,99,7,19]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-103 6M', ...this.extractValues(stock_data_list, [9,27,99,4,13]) },
        { date, stock_code, stock_name, structure: '不追保雪球',total_principal_label: this.total_principal_label, term: '70-100 12M', ...this.extractValues(stock_data_list, [10,28,99,11,22]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103 12M', ...this.extractValues(stock_data_list, [11,29,99,8,17]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100 12M', ...this.extractValues(stock_data_list, [12,30,99,12,21]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103 12M', ...this.extractValues(stock_data_list, [13,31,99,9,16]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100 12M', ...this.extractValues(stock_data_list, [14,32,99,13,20]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103 12M', ...this.extractValues(stock_data_list, [15,33,99,10,15]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-100 12M', ...this.extractValues(stock_data_list, [16,34,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-103 12M', ...this.extractValues(stock_data_list, [17,35,99,99,99]) },

        { date, stock_code, stock_name, structure: '追保雪球',total_principal_label: this.total_principal_label, term: '70-100 6M', ...this.extractValues(stock_data_list, [18,3,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103 6M', ...this.extractValues(stock_data_list, [19,4,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100 6M', ...this.extractValues(stock_data_list, [20,5,99,17,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103 6M', ...this.extractValues(stock_data_list, [21,6,99,14,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100 6M', ...this.extractValues(stock_data_list, [22,7,99,18,9]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103 6M', ...this.extractValues(stock_data_list, [23,8,99,15,4]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-100 6M', ...this.extractValues(stock_data_list, [24,9,99,19,8]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-103 6M', ...this.extractValues(stock_data_list, [25,10,99,16,3]) },
        { date, stock_code, stock_name, structure: '追保雪球',total_principal_label: this.total_principal_label,term: '70-100 12M', ...this.extractValues(stock_data_list, [26,11,99,23,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103 12M', ...this.extractValues(stock_data_list, [27,12,99,20,7]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100 12M', ...this.extractValues(stock_data_list, [28,13,99,24,11]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103 12M', ...this.extractValues(stock_data_list, [29,14,99,21,6]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100 12M', ...this.extractValues(stock_data_list, [30,15,99,25,10]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103 12M', ...this.extractValues(stock_data_list, [31,16,99,22,5]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-100 12M', ...this.extractValues(stock_data_list, [32,17,99,99,99]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '85-103 12M', ...this.extractValues(stock_data_list, [33,19,99,99,99]) },


        { date, stock_code, stock_name, structure: '折价建仓雪球',total_principal_label: this.total_principal_label, term: '70-100-80 6M', ...this.extractValues(stock_data_list, [99,37,99,99,23]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103-80 6M', ...this.extractValues(stock_data_list, [99,38,99,99,24]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100-85 6M', ...this.extractValues(stock_data_list, [99,39,99,99,25]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103-85 6M', ...this.extractValues(stock_data_list, [99,40,99,99,26]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100-90 6M', ...this.extractValues(stock_data_list, [99,41,99,99,27]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103-90 6M', ...this.extractValues(stock_data_list, [99,42,99,99,28]) },
        { date, stock_code, stock_name, structure: '折价建仓雪球',total_principal_label: this.total_principal_label,term: '70-100-80 12M', ...this.extractValues(stock_data_list, [99,43,99,99,29]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '70-103-80 12M', ...this.extractValues(stock_data_list, [99,44,99,99,30]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-100-85 12M', ...this.extractValues(stock_data_list, [99,45,99,99,31]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '75-103-85 12M', ...this.extractValues(stock_data_list, [99,46,99,99,32]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-100-90 12M', ...this.extractValues(stock_data_list, [99,47,99,99,33]) },
        { date: '', stock_code: '', stock_name: '', structure: '', total_principal_label:'',term: '80-103-90 12M', ...this.extractValues(stock_data_list, [99,48,99,99,34]) },

      ];

      this.originalTableData = [...this.tableData];

    },
    extractValues(stock_data_list, indices) {
      console.log(stock_data_list);
      return {
        银河_雪球: (stock_data_list['银河_雪球'] != null && stock_data_list['银河_雪球'][indices[0]] !== undefined) ? stock_data_list['银河_雪球'][indices[0]] : 0,
        中证_雪球: (stock_data_list['中证_雪球'] != null && stock_data_list['中证_雪球'][indices[1]] !== undefined) ? stock_data_list['中证_雪球'][indices[1]] : 0,
        中金_雪球: (stock_data_list['中金_雪球'] != null && stock_data_list['中金_雪球'][indices[2]] !== undefined) ? stock_data_list['中金_雪球'][indices[2]] : 0,
        浙期_雪球: (stock_data_list['浙期_雪球'] != null && stock_data_list['浙期_雪球'][indices[3]] !== undefined) ? stock_data_list['浙期_雪球'][indices[3]] : 0,
        国君_雪球: (stock_data_list['国君_雪球'] != null && stock_data_list['国君_雪球'][indices[4]] !== undefined) ? stock_data_list['国君_雪球'][indices[4]] : 0

      };
    },

  }
}
</script>
<style>
.filter-group {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.el-radio-group {
  display: flex;
  align-items: center;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 8px 10px;
}

.filter-title {
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
}

.el-radio-button {
  margin-left: 8px;
}

.el-radio-button:first-child {
  margin-left: 0;
}

.el-radio-button__inner {
  padding: 8px 15px;
}
.page-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.title-section {
  margin-bottom: 30px;
}

.rules-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 40px;
}

.rule-group {
  margin-bottom: 25px;
}

.rule-group:last-child {
  margin-bottom: 0;
}

.rule-item {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.5;
}

.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>